import { createAsyncThunk } from '@reduxjs/toolkit';
import { HOSTNAME } from '../configs/Domain';


export const fetchWebAssetsList = createAsyncThunk(
  'assets/listAssets',
  async ({ assetKey, page = 0, limit = 30 }, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${HOSTNAME}/assets/list/${assetKey}?page=${page}&limit=${limit}`
      );
      if (!response.ok) {
        throw new Error(`Failed to fetch ${assetKey} assets`);
      }
      const data = await response.json();
      return { assetKey, data };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
